import { ChangeEvent, FC, MouseEvent, useState } from 'react';
import { Controller, FieldError, get, useFormContext } from 'react-hook-form';

import VisibilityOff from '@mui/icons-material/VisibilityOffOutlined';
import Visibility from '@mui/icons-material/VisibilityOutlined';
import { IconButton } from '@mui/material';

import { Input, InputProps } from '../Input';
import { FormElementProps } from '../types';

export interface FormPasswordFieldProps
  extends Omit<InputProps, 'name' | 'onChange'>,
    FormElementProps {
  handleChange?: (name: string, value: string | number) => void;
}

export const FormPasswordField: FC<FormPasswordFieldProps> = (props) => {
  const { name, rules, defaultValue, handleChange, ...rest } = props;
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name) as FieldError;

  const handleMouseDownPassword = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setShowPassword((show) => !show);
  };

  return (
    <Controller
      control={control}
      defaultValue={defaultValue || ''}
      name={name}
      render={({ field }: any) => (
        <Input
          {...rest}
          {...field}
          error={error?.message}
          name={name}
          type={showPassword ? 'text' : props.type}
          onChange={(
            event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
          ) => {
            if (handleChange != null)
              handleChange(event.target.name, event.target.value);
            field.onChange(event);
          }}
          endAdornment={
            <IconButton onClick={handleMouseDownPassword} sx={{ mr: -1 }}>
              {showPassword ? (
                <VisibilityOff fontSize="small" />
              ) : (
                <Visibility fontSize="small" />
              )}
            </IconButton>
          }
        />
      )}
      rules={rules}
    />
  );
};
